import { makeStyles } from "@fluentui/react-components";

export const useStackStyles = makeStyles({
  base: { display: "flex" },
  inline: { display: "inline-flex" },
  wrap: { flexWrap: "wrap" },
  rowDirection: { flexDirection: "row" },
  columnDirection: { flexDirection: "column" },
  // align-items
  alignStart: { alignItems: "flex-start" },
  alignCenter: { alignItems: "center" },
  alignEnd: { alignItems: "flex-end" },
  alignStretch: { alignItems: "stretch" },
  alignBaseline: { alignItems: "baseline" },
  // justify-content
  justifyStart: { justifyContent: "flex-start" },
  justifyCenter: { justifyContent: "center" },
  justifyEnd: { justifyContent: "flex-end" },
  justifyStretch: { justifyContent: "stretch" },
  justifyBetween: { justifyContent: "space-between" },
  justifyAround: { justifyContent: "space-around" },
  justifyEvenly: { justifyContent: "space-evenly" },
});
